<p-dialog
  [header]="dialogTitle"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '700px', minHeight: '500px' }"
  [closable]="true"
  (onHide)="onClose()"
>
  <div class="compose-form">
    @if (errorMessage) {
      <p-message severity="error" [text]="errorMessage" styleClass="compose-error" />
    }

    <div class="form-row">
      <label for="from">Von:</label>
      <input pInputText id="from" [value]="senderAddress" [disabled]="true" class="form-input" />
    </div>

    <div class="form-row">
      <label for="to">An:</label>
      <input
        pInputText
        id="to"
        [(ngModel)]="recipient"
        placeholder="empfaenger@domain.com"
        class="form-input"
        [disabled]="mode === 'reply'"
      />
      @if (domainConfig) {
        <small class="domain-hint">Erlaubte Domains: {{ allowedDomainsText }}</small>
      }
    </div>

    <div class="form-row">
      <label for="subject">Betreff:</label>
      <input
        pInputText
        id="subject"
        [(ngModel)]="subject"
        placeholder="Betreff eingeben"
        class="form-input"
      />
    </div>

    <!-- Dateianhänge -->
    <div class="form-row">
      <label>Anhänge:</label>
      <div class="attachment-area">
        <label class="file-select-btn" for="fileInput">
          <i class="pi pi-paperclip"></i> Dateien auswählen
        </label>
        <input type="file" id="fileInput" multiple (change)="onFilesSelected($event)" class="file-input-hidden" />
        @if (attachedFiles.length > 0) {
          <div class="attached-files">
            @for (file of attachedFiles; track file.name; let i = $index) {
              <span class="att-chip">
                <i class="pi pi-file"></i>
                {{ file.name }} ({{ formatFileSize(file.size) }})
                <i class="pi pi-times remove-btn" (click)="removeFile(i)"></i>
              </span>
            }
          </div>
        }
      </div>
    </div>

    <div class="form-row editor-row">
      <p-editor [(ngModel)]="bodyHtml" [style]="{ height: '250px' }">
        <ng-template #header>
          <span class="ql-formats">
            <button type="button" class="ql-bold"></button>
            <button type="button" class="ql-italic"></button>
            <button type="button" class="ql-underline"></button>
          </span>
          <span class="ql-formats">
            <button type="button" class="ql-list" value="ordered"></button>
            <button type="button" class="ql-list" value="bullet"></button>
          </span>
          <span class="ql-formats">
            <button type="button" class="ql-link"></button>
          </span>
          <span class="ql-formats">
            <button type="button" class="ql-clean"></button>
          </span>
        </ng-template>
      </p-editor>
    </div>
  </div>

  <ng-template #footer>
    <p-button
      label="Abbrechen"
      icon="pi pi-times"
      severity="secondary"
      (onClick)="onClose()"
    />
    <p-button
      label="Senden"
      icon="pi pi-send"
      (onClick)="onSend()"
      [loading]="sending"
    />
  </ng-template>
</p-dialog>
